<ion-header
  *ngIf="{
    isSmall: isSmall$ | async
  } as context"
  class="ion-no-border"
  style="z-index: 500"
>
  <ion-toolbar
    class="primary-toolbar ion-text-center"
    color="primary"
    mode="ios"
  >
    <ion-buttons slot="start" *ngIf="context.isSmall">
      <ion-menu-button mode="md" color="light"></ion-menu-button>
    </ion-buttons>
    <ion-text
      *ngIf="parentTitle && parentUri; else onlyTitle"
      slot="start"
      style="transform: translateY(-2px)"
      class="overflow-ellipsis"
    >
      <a [routerLink]="parentUri" routerDirection="back" class="title-font">
        {{ parentTitle }}
      </a>
      <fa-icon
        [icon]="['fal', 'chevron-right']"
        size="sm"
        style="margin: 0 8px"
      ></fa-icon>
      <span class="title-font">{{ pageTitle }}</span>
    </ion-text>
    <ng-template #onlyTitle>
      <ion-text slot="start" style="transform: translateY(-2px)">
        <span class="title-font">
          {{ pageTitle }}
        </span>
      </ion-text>
      <img *ngIf="logo" [src]="logo" style="max-height: 64px; padding: 12px" />
    </ng-template>

    <ng-content select="[slot=toolbar-center]"></ng-content>

    <ion-buttons slot="end">
      <ng-content select="[slot=toolbar-end]"></ng-content>
    </ion-buttons>

    <div slot="end" class="toolbar-end-group">
      <div *ngIf="toolbarEndExtra" class="toolbar-end-extra">
        <ng-container *ngComponentOutlet="toolbarEndExtra"></ng-container>
      </div>

      <ion-text
        class="clock ion-hide-sm-down"
        *subscribe="currentDateTime$ as dateTime"
      >
        <span class="date ion-hide-md-up">
          {{ dateTime | translocoDate : { dateStyle: 'medium' } }}
        </span>
        <span class="date ion-hide-lg-up ion-hide-md-down">
          {{ dateTime | translocoDate : { dateStyle: 'long' } }}
        </span>
        <span class="date ion-hide-lg-down">
          {{ dateTime | translocoDate : { dateStyle: 'full' } }}
        </span>
        <span class="divider">|</span>
        <span class="time">
          {{ dateTime | translocoDate : { timeStyle: 'short' } }}
        </span>
      </ion-text>
    </div>
    <ion-progress-bar
      type="indeterminate"
      *ngIf="loading && !displaySearch && !tabs?.length"
      color="secondary"
    ></ion-progress-bar>
  </ion-toolbar>
  <ion-toolbar class="secondary-toolbar" *ngIf="tabs?.length > 0" mode="ios">
    <ion-segment
      mode="md"
      [style.max-width]="
        'calc(' +
        (tabs.length + (displayHome ? 1 : 0)) +
        '* ' +
        tabMaxWidth +
        ')'
      "
      [scrollable]="true"
      [(ngModel)]="selectedPath"
    >
      <ion-segment-button
        [routerLink]="rootPath + '/home'"
        value="home"
        class="transition"
        *ngIf="displayHome"
      >
        <fa-icon [icon]="['fal', 'house-window']"></fa-icon>
      </ion-segment-button>
      <ion-segment-button
        *ngFor="let tab of tabs"
        class="transition"
        [routerLink]="rootPath + '/' + tab.path"
        [value]="tab.path"
      >
        {{ tab.name }}
      </ion-segment-button>
    </ion-segment>
    <ion-progress-bar
      type="indeterminate"
      *ngIf="loading && !displaySearch && tabs?.length"
      color="secondary"
    ></ion-progress-bar>
  </ion-toolbar>
  <ion-toolbar mode="ios" color="primary" *ngIf="displaySearch">
    <ion-searchbar
      [placeholder]="searchPlaceholder || 'Zoeken...'"
      [debounce]="searchDebounce"
      (ionInput)="search($event)"
      [value]="params?.['q']"
      [disabled]="disableSearch"
    ></ion-searchbar>
    <ion-buttons slot="end" style="display: flex; gap: 8px; align-items: center">
      <ion-button
        fill="solid"
        class="filter-btn"
        *ngIf="displayFilter"
        (click)="filter()"
      >
        <fa-icon
          [icon]="['fal', 'filters']"
          size="lg"
          slot="icon-only"
        ></fa-icon>
        <ion-badge
          *ngIf="(params | propertyCount : ignoreProps) > 0"
          color="secondary"
        >
          {{ params | propertyCount : ignoreProps }}
        </ion-badge>
      </ion-button>
      <div
        *ngIf="buttons?.length || buttonType !== 'none'"
        style="display: flex; gap: 8px; align-items: center"
      >
        <ion-button
          *ngFor="let button of buttons"
          (click)="button.action()"
          fill="solid"
          [disabled]="button.disabled"
        >
          <fa-icon
            [icon]="['fal', button.icon]"
            slot="icon-only"
            size="lg"
          ></fa-icon>
        </ion-button>
        <ion-button
          fill="solid"
          *ngIf="buttonType !== 'none'"
          [id]="
            buttonType === 'menu' ? 'listSearchMenu-' + menuBtnId : 'btnSearch'
          "
          (click)="buttonClick()"
        >
          <fa-icon
            [icon]="[
              'fal',
              buttonType === 'menu' ? 'ellipsis-vertical' : buttonIcon
            ]"
            size="lg"
            slot="icon-only"
          ></fa-icon>
        </ion-button>
      </div>
    </ion-buttons>
    <ion-progress-bar
      type="indeterminate"
      *ngIf="loading && displaySearch && !tabs?.length"
      color="secondary"
    ></ion-progress-bar>
  </ion-toolbar>
</ion-header>

<ion-content
  scrollY="false"
  [style.height]="
    tabs?.length > 0
      ? 'calc(100vh - 120px - env(safe-area-inset-top))'
      : displaySearch
      ? 'calc(100vh - 106px - env(safe-area-inset-top))'
      : 'calc(100vh - 50px - env(safe-area-inset-top))'
  "
>
  <ng-content></ng-content>
</ion-content>

<ion-popover
  *ngIf="buttonType === 'menu'"
  [trigger]="'listSearchMenu-' + menuBtnId"
  triggerAction="click"
  [dismissOnSelect]="true"
  size="auto"
  style="--min-width: 240px"
>
  <ng-template>
    <ion-content class="ion-background-overlay">
      <ng-content select="[slot=menu]"></ng-content>
    </ion-content>
  </ng-template>
</ion-popover>
